import {HTMLAttributes} from 'react';

export interface OutlinedTabItemProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
  type?: TabType;
}

export enum TabType {
  Outline = 'Outline',
  Background = 'Background',
}
